import React from 'react';
import {createBrowserRouter} from "react-router-dom";
import Error from "../pages/Error";
import Flight from "../pages/Flight";
import App from "../App";
import Terms from "../pages/Terms"
import Home from "../pages/Home";
import Logbook from "../components/Logbook";
import Register from "../components/Register";
import Signin from "../pages/Signin";
import EventRegistration from "../pages/EventRegistration";
import Calendar from "../pages/Calendar/";
import MyEvents from "../pages/MyEvents";
import RuidHandler from "../pages/RuidHandler";
import EventPage from "../pages/Event/";
import Setup from "../pages/Event/setup";
import Pilots from "../pages/Event/pilots";
import Support from "../pages/Support";
import Results from "../pages/Event/Results";
import Briefing from "../pages/Event/Briefing";
import EventHome from "../pages/Event/EventHome";
import EventInfo from "../pages/Event/EventInfo";
import RegistrationInfo from "../pages/Event/RegistrationInfo";
import ResetPassword from "../pages/ResetPassword";
import EventIndexPage from "../pages/Event/EventIndexPage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <Error/>,
        children: [
            {
                index:true,
                element:<Home/>,
            },
            {
                path:'myEvents',
                element:<MyEvents/>,
            },
            {
                path:'calendar',
                element:<Calendar/>,
            },
            {
                path:"logbook",
                element:<Logbook/>
            },
            {
                path:'view/flight/:flightId',
                element: <Flight/>,
            },
            {
                path:"event",
                element:<EventPage/>,
                children:[
                    {
                        index:true,
                        element:<EventIndexPage/>,
                    },
                    {
                        path:'pilots',
                        element:<Pilots/>,
                    },
                    {
                        path:'results',
                        element:<Results/>,
                    },
                    {
                        path:'home',
                        element:<EventHome/>,
                        children:[
                            {
                                index:true,
                                element:<EventInfo/>,
                            },
                            {
                                path:'info',
                                element:<EventInfo/>,
                            },
                            {
                                path:'registration',
                                element:<RegistrationInfo/>,
                            },
                            {
                                path:'briefing',
                                element:<Briefing/>,
                            },
                            {
                                path:'settings',
                                element:<Setup/>,
                            },
                        ],
                    },
                ],
            },
            {
                path:"support",
                element:<Support/>,
            },
            {
                path:"signin",
                element:<Signin/>
            },
            {
                path:"terms",
                element:<Terms/>
            },
            {
                path:'register',
                element:<Register/>
            },
            {
                path:'eventRegistration/:eventId',
                element:<EventRegistration/>,
            },
            {
                path:'ruid/:ruid',
                element:<RuidHandler/>,
            },
            {
                path:'resetPassword/:ruid',
                element:<ResetPassword/>,
            },
            {
                path:'eventRegistration',
                element:<EventRegistration/>,
            },
        ],
    },
]);

export default router;